import { makeStyles } from '@material-ui/core/styles';
import { GiftOrderSummaryItemSize } from 'features/dashboard/components/GiftOrderSummaryItem';

interface CheckboxFieldProps {
  size: GiftOrderSummaryItemSize;
}

export const useStyles = makeStyles(theme => ({
  container: {
    marginTop: '30px',
    border: `1px solid #FF3D3D`,
    borderRadius: theme.spacing(10),
    padding: ({ size }: CheckboxFieldProps) => (size === 'medium' ? theme.spacing(15, 15, 20) : theme.spacing(11, 12)),
  },
  header: {
    fontSize: 24,
    fontWeight: 600,
    color: '#FF3D3D',
    marginBottom: 10,
  },
  row: {
    padding: '2px 0',
  },
}));
